module.exports = __webpack_public_path__ + "static/media/wcn_flow.dfd60c5c.pdf";